
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Model.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

import { QuestionModel } from './Entities.GormCrm.Question';
import { Model, ModelProperty } from 'models/Model';


export class QuestionTagModel extends Model<QuestionTagModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'tag', type: 'string' },
		{ name: 'questionId', type: 'string' },
		{ name: 'question', type: 'QuestionModel', isHidden: true, isObject: true, new: () => { return new QuestionModel }, properties: () => { return QuestionModel.classProperties } }
	];
	[key: string]: any;
	
	public tag: string;
	public questionId?: string;
	public question?: QuestionModel;
    
	constructor(){
		super();
		this.tag = '';
		this.questionId = undefined;
		this.question = undefined;
		
	}
	getProperties(){
		return QuestionTagModel.classProperties;
	}
}

